export default {
  methods: {
    toPage(path) {
      this.$router.push(path)
    }
  }
}
